import {useEffect, useRef, useState} from "react";
import styled from "styled-components/macro";
import ReactCommonmark from 'react-commonmark';
import Textarea from 'react-textarea-autosize';

import FieldLabel from "./field_label";
import Button from "./button";
import {themecolors} from "../utils/themecolors";

let textFieldEdit;

const Toolbar = styled.div`
  display: flex;
  align-items: center;
  font-size: 14px;
  color: ${({theme}) => theme.label.color};
  ${Button} {
    color: ${({theme}) => theme.label.color};
  }
`;
const Edit = styled(Textarea)`
`;
const Preview = styled(ReactCommonmark)`
  background-color: ${({theme}) => theme.color.name === 'dark' ? 'inherit' : themecolors.pure_white};
  border: ${({theme}) => theme.color.name === 'dark' ? `1px solid ${theme.dark_border}` : `${theme.form.inputBorder} solid #ddd`};
  border-radius: 4px;
  margin-top: 4px;
  padding: 10px 12px;
  font-size: 14px;
  p:last-of-type {
    margin-bottom: 0;
  }
  a {
    color: ${({theme}) => theme.placeholder_link_2};
  }
`;

const MarkdownField = styled(({className, id, label, placeholder, value, onChange, minRows= 5, maxRows=15, autofocus, readOnly, form}) => {
    const textareaRef = useRef(null);
    useEffect(() => {
        if (!textFieldEdit) {
            textFieldEdit = require('text-field-edit');
        }
        if (autofocus) {
            textareaRef.current?.focus();
        }
    }, [autofocus]);
    const [preview, setPreview] = useState(false);
    const handleChange = (event) => {
        onChange(event.currentTarget.value);
    };
    const italic = () => {
        textFieldEdit.wrapSelection(textareaRef.current, '*');
    };
    const bold = () => {
        textFieldEdit.wrapSelection(textareaRef.current, '**');
    };
    const quote = () => {
        let text = textFieldEdit.getSelection(textareaRef.current);
        text = text.split('\n').map((line) => `> ${line}`).join('\n')
        textFieldEdit.insert(textareaRef.current, text);
    };
    const link = () => {
        const text = textFieldEdit.getSelection(textareaRef.current) || `enter text`;
        // eslint-disable-next-line no-alert
        const url = window.prompt(`Where would you like to link to?`);
        if (url !== null) {
            textFieldEdit.insert(textareaRef.current, `[${text}](${url})`);
        }
    };
    return (
        <div className={className}>
            {label && <FieldLabel htmlFor={id}>{label}</FieldLabel>}
            {preview
                ? <Preview source={value||""} skipHtml />
                : <Edit
                    id={id} value={value} onChange={handleChange}
                    minRows={minRows} maxRows={maxRows}
                    placeholder={placeholder}
                    maxLength={15000}
                    ref={textareaRef}
                    readOnly={readOnly}
                />}
        </div>
    )
})`
  display: flex;
  flex-direction: column;
  margin-bottom: 12px;
  textarea {
    border: ${({theme, form}) => theme.color.name === 'dark' ? `1px solid ${themecolors.dark_background_10}` : `1px solid ${form ? '#e2e8f0' : themecolors.light_border}`};
    border-radius: 6px;
    padding: 12px 16px;
    width: 100%;
    font-size: 15px;
    font-family: inherit;
    resize: none;
    ${({theme}) => `
        color: ${theme.control.color};
        background-color: ${theme.color.name === 'dark' ? 'inherit' : themecolors.pure_white};
    `}
  }
  textarea::placeholder {
    color: ${({theme}) => theme.color.name === 'dark' ? themecolors.dark_low_impact_text : themecolors.light_low_impact_text};
  }
  ${Button} {
    background-color: transparent;
  }
  @media only screen and (max-width: 780px) {
    ${Toolbar} {
      display: none;
  }
`;

export default MarkdownField;
